module.exports = __webpack_public_path__ + "media/assets/ClickedRightCheck-83a9b5e85f227ff02685c73b0526c702.svg";